import {
	ChangeDetectionStrategy,
	Component,
	computed,
	input,
	model,
	OnInit,
	output,
	signal,
} from '@angular/core';

import { AvailabilityWidgetInputComponent } from '../availability-input/availability-input';

import { AvailabilityInputDropdownItem } from './availability-input-dropdown.interface';

@Component({
	changeDetection: ChangeDetectionStrategy.OnPush,
	selector: `vp-availability-widget-input-dropdown`,
	templateUrl: './availability-input-dropdown.html',
	imports: [AvailabilityWidgetInputComponent],
})
export class AvailabilityWidgetInputDropdownComponent implements OnInit {
	className = input('');
	inputName = input.required<string>();
	items = input<AvailabilityInputDropdownItem[]>();
	excludeFromClosingRegex = input<RegExp | string>(/ng-option/);
	label = input.required<string>();
	placeholder = input.required<string>();
	selectFirstItem = input<boolean>(false);

	itemSelected = output<AvailabilityInputDropdownItem>();

	selectedItemName = signal<string>('');
	isOpen = model<boolean>(false);
	iconName = computed<string>(() => {
		if (this.items().length > 1) {
			return this.isOpen() ? 'icon-chevron-up' : 'icon-chevron-down';
		}
		return '';
	});

	ngOnInit(): void {
		if (this.items().length === 1 || this.selectFirstItem()) {
			this.onSelectItem(this.items()[0]);
		}
	}

	popoverStateChanged(isOpen: boolean) {
		this.isOpen.set(isOpen);
	}

	onSelectItem(item: AvailabilityInputDropdownItem) {
		this.selectedItemName.set(item.name);
		this.popoverStateChanged(false);
		this.itemSelected.emit(item);
	}
}
